import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue'
import { initNotifications, stopNotifications } from '@/services/notifications'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsCenter',
  setup(__props) {

const renderRoot = ref<HTMLDivElement>()
onMounted(async () => {
  if (renderRoot.value) {
    await initNotifications(renderRoot.value)
  }
})

onUnmounted(() => {
  stopNotifications()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "renderRoot",
    ref: renderRoot
  }, null, 512 /* NEED_PATCH */))
}
}

})